import styled from 'styled-components';
import { getTextPresetCss } from '@optimus-web/common';
import { TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { ListItem, ListItemProps } from '../ListItem';
import { NestedCard } from '../NestedCard';

const CardContainer = styled(NestedCard)`
    overflow: hidden;
`;

export interface NavigationCardProps extends ListItemProps {
    disableEvent?: boolean;
}

const NavigationListItem = styled(ListItem).withConfig<NavigationCardProps>({
    shouldForwardProp: (prop) => !['disableEvent'].includes(prop),
})`
    height: 60px;
    ${getTextPresetCss(TEXT_PRESET_KEY['300m'])}
    ${(props) => props.disableEvent && 'pointer-events: none;'}
`;

const NavigationCard = (props: NavigationCardProps) => (
    <CardContainer padding="0">
        <NavigationListItem {...props} />
    </CardContainer>
);

export default NavigationCard;
